import React from 'react';
import bgImage from './dlsu-bg.webp';
import { Link } from 'react-router-dom';
import { FaBook, FaYoutube, FaChalkboardTeacher, FaFacebook, FaInstagram, FaEnvelope } from 'react-icons/fa';
import logo from '../Navbar/syntax_white.png';

const Home = () => {
  return (
    <div className="relative min-h-screen w-full">
      {/* Transparent Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-10 text-white py-4 px-6">
        <div className="container mx-auto flex justify-between items-center">
          {/* Logo and Title */}
          <Link to="/" className="flex items-center space-x-2">
            <img src={logo} alt="Logo" className="h-8 w-8" />
            <div className="text-lg font-bold font-header">
              DLSU SYNTAX
            </div>
          </Link>
        </div>
      </nav>

      {/* Banner Section */}
      <div 
        className="relative min-h-screen w-full"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Blur overlay */}
        <div className="absolute inset-0 backdrop-blur-sm bg-[#005152] bg-opacity-60"></div>
        
        {/* Content Container */}
        <div className="relative flex flex-col min-h-screen">
          {/* Main Content - vertically centered */}
          <div className="flex-1 flex flex-col items-center justify-center px-4 py-20">
            <div className="text-center text-white mb-12">
              <h1 className="text-5xl md:text-7xl font-bold font-header mb-4">DLSU SYNTAX</h1>
              <p className="text-lg md:text-xl font-body">Paving Your Way to Excellence</p>
            </div>
            
            {/* Offerings in Banner */}
            <div className="flex flex-wrap justify-center gap-4 px-4">
              <Link 
                to="/reviewers"
                className="w-full sm:w-auto px-8 py-4 bg-transparent text-white border-2 border-white rounded-lg hover:bg-white hover:text-[#005152] transition-all font-body inline-flex items-center justify-center gap-2 text-lg"
              >
                <FaBook className="text-2xl" />
                Reviewers
              </Link>
              <Link
                to="/syntube" 
                className="w-full sm:w-auto px-8 py-4 bg-transparent text-white border-2 border-white rounded-lg hover:bg-white hover:text-[#005152] transition-all font-body inline-flex items-center justify-center gap-2 text-lg"
              >
                <FaYoutube className="text-2xl" />
                SYNTube
              </Link>
              <a 
                href="https://docs.google.com/forms/d/e/1FAIpQLSeQHpq-HHO_zhAm-vwTVQWf0gNKWkD8ghw60MDEvUVhCPFoag/viewform"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-4 bg-transparent text-white border-2 border-white rounded-lg hover:bg-white hover:text-[#005152] transition-all font-body inline-flex items-center justify-center gap-2 text-lg"
              >
                <FaChalkboardTeacher className="text-2xl" />
                Tutorials
              </a>
            </div>
          </div>

          {/* Footer - always at bottom */}
          <footer className="relative w-full text-white py-4 px-6">
            <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
              {/* Footer Text */}
              <div className="text-center md:text-left mb-4 md:mb-0">
                <p className="font-body">Society of Young Engineers</p>
                <p className="font-body">Toward Achieving Excellence</p>
              </div>

              {/* Social Media Icons */}
              <div className="flex space-x-6">
                <a href="https://www.facebook.com/DLSU.SYNTAX" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors">
                  <FaFacebook className="h-6 w-6" />
                </a>
                <a href="https://www.instagram.com/dlsu.syntax/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors">
                  <FaInstagram className="h-6 w-6" />
                </a>
                <a href="mailto:syntax@dlsu.edu.ph" className="hover:text-gray-400 transition-colors">
                  <FaEnvelope className="h-6 w-6" />
                </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Home;
